import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Layout, Typography, Alert } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import TramittaLogo from '../../images/tramitta-logo.png';
import LegalChileLogo from '../../images/legalchile.svg';
import YapoLogo from '../../images/yapo_logo.png';
import { EXTERNAL_URL } from '../../config/constants/urls';
import PropTypes from 'prop-types';

const { Header, Content } = Layout;
const { Title } = Typography;

const CreationSuccess = ({ sourceUrl }) => {

  return (
    <React.Fragment id="payment-success">
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          {sourceUrl === EXTERNAL_URL.YAPO &&
            <img src={YapoLogo} alt="" className="yapo-logo" />
          }
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <Content className="ant-layout-content-custom">
        <Row className="mb-4">
          <Col md={12} className="text-center mx-auto">
            <CheckCircleOutlined style={{ fontSize: '64px', color: '#43EEBB' }} className="mb-2" />
            <Title level={1}>Pago exitoso</Title>
            <p>Tu compra ha sido procesada exitosamente. A continuación enviaremos un correo electrónico a los firmantes para que puedan revisar el contrato de arriendo.</p>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col md={16} lg={9} className=" mx-auto">
            <Alert message="El comprobante de pago fue enviado al correo ingresado en los detalles de facturación." className="mb-2" />
          </Col>
        </Row>

      </Content>
    </React.Fragment>
  );
};

CreationSuccess.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
};

const data = (state) => ({
  sourceUrl: state.contract.sourceUrl
});

export default connect(data, null)(CreationSuccess);